import { PRIMARY_TRAVELLER_FORM_ID } from 'constants/checkout'
import { arrayToObject } from 'lib/array/arrayUtils'
import { flattenFormFields } from 'lib/checkout/form'
import { getAttribute } from 'lib/object/objectUtils'

interface FormPayload {
  [fieldId: string]: string
}

interface Item {
  form: App.Checkout.TravellerForm,
  schema: App.Checkout.TravellerFormSchema,
}

interface TravellerInformationPayload {
  customer: FormPayload | null;
  participants?: Array<FormPayload>
}

function buildParticipantPayload(item: Item, formSchema: App.Checkout.FormSchema): FormPayload {
  const fieldKeys = Object.keys(flattenFormFields(item.schema.properties, formSchema))

  // Temporary until old phone field is removed from schemas
  if (!fieldKeys.includes('phone') && fieldKeys.includes('phonePrefix')) {
    fieldKeys.push('phone')
  }

  return fieldKeys.reduce<{[key: string]: string}>((participant, property) => {
    const value = item.form && getAttribute(item.form, property)

    if (value) {
      participant[property] = value
    }

    return participant
  }, {})
}

export function buildTravellerInfo(
  schema: App.Checkout.FormSchema,
  forms: Array<App.Checkout.TravellerForm>,
): TravellerInformationPayload {
  const formsMap = arrayToObject(forms, form => form.id, form => form)

  const customerItem = {
    form: formsMap[PRIMARY_TRAVELLER_FORM_ID],
    schema: schema.properties[PRIMARY_TRAVELLER_FORM_ID],
  }

  const participantItems = Object.entries<App.Checkout.TravellerFormSchema>(schema.properties)
    .reduce((acc, [key, schema]) => {
      if (!schema.isParticipant) { return acc }
      return [...acc, { form: formsMap[key], schema }]
    }, [] as Array<Item>)

  const participantPayloadItems = participantItems.map(item => buildParticipantPayload(item, schema))

  return {
    customer: buildParticipantPayload(customerItem, schema),
    ...(participantPayloadItems.length > 0 ? { participants: participantPayloadItems } : {}),
  }
}
